import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { useUserInfor } from "../../../../../../../Context/User";
import { ListarCategoriaAtendimentoPaiController } from "../../../../../../../Controllers/Geral/CategoriaAtendimento/CategoriaAtendimentoController";
import { AtualizarConfigGeralController } from "../../../../../../../Controllers/Geral/GestaoDeCadastros/ConfigGeral/ConfigGeralController";
import UnForm from "../../../../../../Form";
import { useEffect, useState } from "react";
import { IConfigGeral_URA } from "../../../../../../../Interfaces/Geral/GestaoDeCadastro/ConfigGeral/ConfigGeralInterface";
import OrSpinner from "../../../../../../Utils/OrSpinner";
import { IConfigGeralModulos } from "../../../../../../../Interfaces/Geral/ConfigGeral/ConfigGeral";
import useAsyncEffect from "../../../../../../../hooks/useAsyncEffect";
import { GetConfigModuloController } from "../../../../../../../Controllers/Geral/ConfigGeral/ConfigGeralController";

interface IAtendimentoClienteConfig {
    lstConfigModulo: IConfigGeralModulos[] | undefined;
    AtualizarConfigModulo: (requestBody: IConfigGeralModulos) => Promise<any>;
    ListConfigModulo: (...args: any[]) => Promise<IConfigGeralModulos[]>;
    lstConfigModuloLoading: boolean;
}

export default function AtendimentoClienteConfig(
    props: IAtendimentoClienteConfig
) {
    const { Config, updateConfig } = useUserInfor();
    const config = Config.ConfigTriagemDTO;
    let configUra = Config.ConfigsUraDTO;
    const [findCategoria, setFindCategoria] = useState<
        IConfigGeral_URA | undefined
    >();
    const [loading, setLoading] = useState(true);

    const idModuloAtendimento = props.lstConfigModulo?.find(
        (lst) => lst.ID_MODULO === 2
    );

    const { value: getConfigModulo } = useAsyncEffect(async () => {
        if (idModuloAtendimento) {
            return GetConfigModuloController(idModuloAtendimento.ID_MODULO);
        }
    }, [idModuloAtendimento]);

    function update() {
        AtualizarConfigGeralController({
            ...Config,
            ConfigTriagemDTO: {
                ...config,
            },
            ConfigsUraDTO: configUra,
        }).then(() => {
            updateConfig();
        });
    }
    useEffect(() => {
        if (loading) {
            const findCategoriaAtendimento = configUra?.find((config) => {
                return config.ID_TIPO_CASO === 2;
            });
            setFindCategoria(findCategoriaAtendimento);
            setLoading(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [configUra]);

    const handleSubmit = (formValue: any) => {
        config.ID_CATEGORIA_ATENDIMENTO_TRIAGEM =
            formValue.ID_CATEGORIA_ATENDIMENTO;
        configUra = formValue.ID_CATEGORIA_ATENDIMENTO_URA
            ? [
                  {
                      ID_CATEGORIA_ATENDIMENTO:
                          formValue.ID_CATEGORIA_ATENDIMENTO_URA,
                      ID_TIPO_CASO: 2,
                  },
              ]
            : configUra;
        update();
    };

    return (
        <OrSpinner loading={loading} loadingColor="primary">
            <div className="col-12 mb-4">
                <h4>Triagem Automática</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Serviço que faz a triagem onde caso essa opção estiver
                        ativada, irá abrir um atendimento automaticamente
                    </label>
                    <div className="col-6">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={config?.FL_TRIAGEM_TELA}
                                    onChange={() => {
                                        config.FL_TRIAGEM_TELA =
                                            !config.FL_TRIAGEM_TELA;
                                        if (
                                            config.ID_CATEGORIA_ATENDIMENTO_TRIAGEM !==
                                            0
                                        ) {
                                            config.ID_CATEGORIA_ATENDIMENTO_TRIAGEM = 0;
                                        }
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>
            <div className="col-12 mb-4">
                <h4>Abrir novo atendimento</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Abrir novo atendimento ao receber resposta do cliente no
                        email de finalização do caso.
                    </label>
                    <div className="col-6">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={
                                        getConfigModulo?.ConfigModuloCampo
                                            .FL_CRIAR_ATEND_RESPOSTA_EMAIL
                                    }
                                    onChange={(e) => {
                                        props
                                            .AtualizarConfigModulo({
                                                ConfigModuloCampo: {
                                                    FL_CRIAR_ATEND_RESPOSTA_EMAIL:
                                                        Boolean(
                                                            e.target.checked
                                                        ),
                                                },
                                                ID_MODULO:
                                                    getConfigModulo?.ID_MODULO ??
                                                    0,
                                            })
                                            .then(() => {
                                                props.ListConfigModulo();
                                                updateConfig();
                                            });
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>
            <UnForm handleSubmit={handleSubmit}>
                <div className="d-flex align-items-center">
                    {config?.FL_TRIAGEM_TELA ? (
                        <>
                            <div className="col-6">
                                <UnForm.LazySelect
                                    controller={() =>
                                        ListarCategoriaAtendimentoPaiController(
                                            2
                                        )
                                    }
                                    getDS={(ca) => ca.DS_CATEGORIA_ATENDIMENTO}
                                    getKeyValue={(ca) =>
                                        ca.ID_CATEGORIA_ATENDIMENTO
                                    }
                                    defaultValue={
                                        config.ID_CATEGORIA_ATENDIMENTO_TRIAGEM
                                    }
                                    name="ID_CATEGORIA_ATENDIMENTO"
                                    label="Categoria de Atendimento"
                                    registerOptions={{
                                        required:
                                            "Insira uma Categoria de atendimento",
                                    }}
                                />
                            </div>
                        </>
                    ) : null}
                </div>
                <div className="d-flex flex-column col-12 col-md-6">
                    <label className="pt-2">
                        Categoria atendimento{" "}
                        <span className="font-weight-bolder">URA</span>
                    </label>
                    <UnForm.SelectCategoriaAtendimento
                        ID_MODULO={2}
                        defaultValue={findCategoria?.ID_CATEGORIA_ATENDIMENTO}
                        name="ID_CATEGORIA_ATENDIMENTO_URA"
                    />
                </div>
                <div className="d-flex align-items-center">
                    <div>
                        <label></label>
                        <UnForm.SubmitButton
                            color="success"
                            icon={faPaperPlane}
                            loadingSize="sm"
                        >
                            Atualizar Categoria
                        </UnForm.SubmitButton>
                    </div>
                </div>
            </UnForm>
        </OrSpinner>
    );
}
